import React, { useContext } from "react";
import {
  BoldLink,
  BoxContainer,
  FormContainer,
  Input,
  MutedLink,
  SubmitButton,
} from "./common";
import { Marginer } from "../marginer/marginer";
import { AccountContext } from "./accountContext";

export function SignupForm(props) {
  const { switchToSignin } = useContext(AccountContext);

  return (
    <BoxContainer>
      <FormContainer>
        <Input type="text" placeholder="نام کاربری" />
        <Input type="email" placeholder="ایمیل" />
        <Input type="password" placeholder="کلمه عبور" />
        <Input type="password" placeholder="تایید کلمه عبور" />
      </FormContainer>
      <Marginer direction="vertical" margin={10} />
      <SubmitButton type="submit">ثبت</SubmitButton>
      <Marginer direction="vertical" margin="1em" />
      <MutedLink href="#">
        حساب کاربری دارید ؟
        <BoldLink href="#" onClick={switchToSignin}>
          وارد شوید
        </BoldLink>
      </MutedLink>
    </BoxContainer>
  );
}
